import { Outlet } from "react-router-dom";
import { useEffect, useState } from "react";
import Sidebar from "@/components/Sidebar";

export default function AppLayout() {
  const [collapsed, setCollapsed] = useState(false);

  useEffect(() => {
    const observer = new MutationObserver(() => {
      setCollapsed(document.body.dataset.sidebar === "collapsed");
    });

    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ["data-sidebar"],
    });

    setCollapsed(document.body.dataset.sidebar === "collapsed");

    return () => observer.disconnect();
  }, []);

  return (
    <div className="flex h-screen bg-gray-50">
      <Sidebar />

      <main
        className="flex-1 overflow-y-auto transition-all duration-300"
        style={{
          marginLeft: collapsed ? "82px" : "250px",
        }}
      >
        <div className="min-h-screen p-6">
          <div className="w-full max-w-[1400px]">
            <Outlet />
          </div>
        </div>
      </main>
    </div>
  );
}
